export default {
  title: "Regra tipo 3 - Alocação máxima de colaboradores em CCs",
  subtitle: "Qual projeto que um colaborador deve ser alocado? O sistema irá alocá-lo apenas nos projetos aqui especificados. Pode ter mais de uma regra por colaborador. Deixar a alocação em branco o sistema usará o valor padrão (Regra 1)",
  token: "collab_allocation_in_proj",
  orderBy: "value_a",
  convert: {
    param: "value_a",
    method: "collaborator_registration",
  },
  tables: [
    {
      type: "general",
      title: "Regra geral",
      actions: "edit_remove",
      columns: [
        {
          label: "Colaborador",
          key: "value_a",
        },
        {
          label: "Centro de custo",
          key: "value_b",
          placeholder: "Todos",
          value: "*",
        },
        {
          label: "Nome do CC",
          key: "value_b",
          placeholder: "Todos",
          value: "*",
          convert: {
            method: "project_id_to_id_name"
          }
        },
        {
          label: "Alocação máxima",
          key: "value_c",
          type: "percent",
          placeholder: "Padrão",
          value: null,
        },
      ],
      data: [],
    },
  ],
  drawer: {
    title: {
      insert_label: "Adicionar Regra",
      update_label: "Editar Regra",
    },
    subtitle:
      "Alocação máxima de colaboradores em Centros de Custos específicos (alocar apenas nos CCs especificados).",
    form: [
      {
        label: "Informe o Colaborador:",
        type: "list_collaborator",
        key: "value_a",
        placeholder: "",
        value: "*",
        visible: false,
      },
      {
        label: "Informe o Centro de Custo:",
        type: "list",
        info: "Acrescente * para selecionar todos",
        key: "value_b",
        placeholder: "",
        value: "*",
        visible: false,
      },
      {
        label: "Informe a alocação máxima do Centro de Custo:",
        info: "Campo opcional",
        type: "percent",
        key: "value_c",
        value: null,
        visible: true,
      },
    ],
  },
};
